import React, { useMemo } from "react";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import { connect } from "react-redux";
import CurrencyProvider from "../../components/Forms/CurrencyProvider";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import { formatTitle } from "../../../utils/formatting";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";

function NotificationForm(props) {
  const endPoint = useMemo(() => {
    return "core/notifications";
  }, []);

  const { currency, menukaartVestigingId, vestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });
  useSwitchToSalesarea(vestiging);

  return (
    <AuthProvider prefix={"notifications"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.titel);
            }}
            endPoint={endPoint}
            extraFields={extraFields}
            extraFormProps={{ vestiging, vestigingId, menukaartVestigingId }}
            mode={"onSubmit"}
            onGetModel={onGetModel}
            pageTitle={getTranslation("notifications.form.pageTitle", "Berichten")}
            parseInput={
              {
                // translations: (response) => (response ? JSON.parse(response) : null),
                // rawApiData: (response) => (response ? JSON.parse(response) : null),
              }
            }
            revalidateMode={"onChange"}
            tabs={[
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tKey={"notifications.form.tabs.algemeen"} tDefault={"Algemeen"} />,
                tabContent: <Algemeen />,
              },
            ]}
            // parseOutput={{ translations: (translations) => (translations ? JSON.stringify(translations) : null) }}
            // objectsExcludedAsRelation={{ translations: true, rawApiData: true }}
            rootRight={"notifications"}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(NotificationForm);
